var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { getPluginOptions, usePlateEditorRef, ELEMENT_MENTION, getMentionOnSelectItem, Combobox, comboboxStore, useEventEditorSelectors, } from '@udecode/plate';
export const MentionPopover = (_a) => {
    var _b, _c;
    var { pluginKey = ELEMENT_MENTION, id = pluginKey, onMentionSearchChange, editorId, items } = _a, props = __rest(_a, ["pluginKey", "id", "onMentionSearchChange", "editorId", "items"]);
    const search = useRef('');
    const editor = usePlateEditorRef(editorId);
    const { trigger } = getPluginOptions(editor, pluginKey);
    const activeId = comboboxStore.use.activeId();
    const focusedEditorId = useEventEditorSelectors.focus();
    const open = (_b = comboboxStore.use.isOpen()) !== null && _b !== void 0 ? _b : false;
    const text = (_c = comboboxStore.use.text()) !== null && _c !== void 0 ? _c : '';
    const isOpen = !(!open || focusedEditorId !== editor.id || activeId !== id);
    useEffect(() => {
        if (isOpen && text !== search.current) {
            search.current = text;
            if (onMentionSearchChange) {
                onMentionSearchChange(text);
            }
        }
    }, [isOpen, text, search, onMentionSearchChange]);
    return (React.createElement(Combobox, Object.assign({ id: id, trigger: trigger, controlled: true, onSelectItem: getMentionOnSelectItem({
            key: pluginKey,
        }), items: text ? items : [], styles: {
            root: {
                zIndex: 10000,
            },
        } }, props)));
};
//# sourceMappingURL=MentionPopover.js.map